module.exports = __webpack_public_path__ + "media/images/icon/upload-ffdc91a9e5ff999971268d1e02daae9b.svg";